import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { MainPaths } from '@routing/main/mainPaths';

const RealtorIcon: React.FC = () => {
  const { pathname } = useLocation();

  const isActive = useMemo(() => pathname.includes(MainPaths.REALTOR), [pathname]);

  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        strokeWidth="0.25"
        d="M9.14898 0.409044C9.75111 0.304439 10.3699 0.25 11.0009 0.25C16.938 0.25 21.7509 5.06294 21.7509 11C21.7509 16.9371 16.938 21.75 11.0009 21.75C7.99386 21.75 5.27406 20.5144 3.32389 18.525C3.03392 18.2292 3.03864 17.7544 3.33443 17.4644C3.5818 17.2219 3.95439 17.1855 4.23935 17.3531L4.79367 16.4109C5.46746 15.2657 6.69701 14.5625 8.02578 14.5625H13.9694C15.2982 14.5625 16.5277 15.2657 17.2015 16.4109L17.7436 17.3324C19.2984 15.6774 20.2509 13.4499 20.2509 11C20.2509 5.89137 16.1095 1.75 11.0009 1.75C10.4564 1.75 9.92343 1.79697 9.40572 1.88691C8.99762 1.95781 8.60932 1.68445 8.53842 1.27635C8.46752 0.868247 8.74088 0.479942 9.14898 0.409044ZM11.0009 20.25C8.89099 20.25 6.94682 19.5442 5.39033 18.3549L6.08651 17.1716C6.49079 16.4844 7.22852 16.0625 8.02578 16.0625H13.9694C14.7667 16.0625 15.5044 16.4844 15.9087 17.1716L16.6069 18.3583C15.0514 19.5451 13.1085 20.25 11.0009 20.25Z"
        fill={isActive ? 'currentColor' : '#98a1b2'}
      />
      <path
        strokeWidth="0.25"
        d="M7.15927 2.55323C7.53762 2.38463 7.70766 1.94124 7.53906 1.56289C7.37046 1.18454 6.92708 1.01451 6.54873 1.1831C6.36447 1.26521 6.18295 1.3523 6.00436 1.44421C5.63605 1.63373 5.49112 2.08595 5.68065 2.45426C5.87017 2.82257 6.32239 2.9675 6.6907 2.77797C6.84445 2.69886 7.00069 2.62389 7.15927 2.55323Z"
        fill={isActive ? 'currentColor' : '#98a1b2'}
      />
      <path
        strokeWidth="0.25"
        d="M4.37998 4.46045C4.67354 4.16822 4.67463 3.69335 4.38241 3.39979C4.09018 3.10623 3.61531 3.10514 3.32175 3.39737C2.99637 3.72127 2.69163 4.06579 2.40967 4.42882C2.15559 4.75596 2.21482 5.22713 2.54196 5.4812C2.8691 5.73528 3.34026 5.67605 3.59434 5.34891C3.83714 5.03629 4.09963 4.73952 4.37998 4.46045Z"
        fill={isActive ? 'currentColor' : '#98a1b2'}
      />
      <path
        strokeWidth="0.25"
        d="M2.30938 7.59242C2.4627 7.20762 2.27505 6.7714 1.89026 6.61808C1.50546 6.46476 1.06924 6.65241 0.915918 7.0372C0.617984 7.78494 0.401835 8.57384 0.278471 9.39276C0.216769 9.80235 0.498789 10.1844 0.908381 10.2461C1.31797 10.3078 1.70003 10.0258 1.76174 9.61621C1.86776 8.9124 2.05345 8.23474 2.30938 7.59242Z"
        fill={isActive ? 'currentColor' : '#98a1b2'}
      />
      <path
        strokeWidth="0.25"
        d="M1.74323 12.2547C1.68734 11.8443 1.30931 11.5569 0.89889 11.6128C0.488464 11.6687 0.201057 12.0467 0.256948 12.4571C0.436505 13.7757 0.856152 15.0185 1.47035 16.1399C1.66931 16.5032 2.12512 16.6364 2.48842 16.4375C2.85171 16.2385 2.98493 15.7827 2.78596 15.4194C2.25795 14.4553 1.89752 13.3877 1.74323 12.2547Z"
        fill={isActive ? 'currentColor' : '#98a1b2'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        strokeWidth="0.25"
        d="M11.0001 4.75C8.65288 4.75 6.75009 6.65279 6.75009 9C6.75009 11.3472 8.65288 13.25 11.0001 13.25C13.3473 13.25 15.2501 11.3472 15.2501 9C15.2501 6.65279 13.3473 4.75 11.0001 4.75ZM8.25009 9C8.25009 7.48122 9.48131 6.25 11.0001 6.25C12.5189 6.25 13.7501 7.48122 13.7501 9C13.7501 10.5188 12.5189 11.75 11.0001 11.75C9.48131 11.75 8.25009 10.5188 8.25009 9Z"
        fill={isActive ? 'currentColor' : '#98a1b2'}
      />
    </svg>
  );
};

export default RealtorIcon;
